import Arabhost from '../../img/Arabhost.png'


export const MyWorkData = [
            {
                        typeofWork: 'Web Developer',
                        img: Arabhost,
                        link: 'https://ar-ab.com'
            }
]